import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

import { COGNITO_STATE } from 'utils/cognito.util';

const StatefulRoute = ({ component: Component, onDidMount, onWillUnmount, ...rest }) => {
  const isAuthenticated = useSelector((state) => state.cognito.state === COGNITO_STATE.in);
  const inProgress = useSelector((state) => state.cognito.state === COGNITO_STATE.loading);

  useEffect(() => {
    onDidMount && onDidMount();
    return () => void (onWillUnmount && onWillUnmount());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (inProgress) return <Route {...rest} render={() => <div> Loading ... </div>} />;

  if (isAuthenticated) return <Route {...rest} render={(props) => <Component {...props} />} />;

  return <Route {...rest} render={(props) => <Redirect to={{ pathname: '/', state: { from: props.location } }} />} />;
};

export default StatefulRoute;
